export const WEBSITE_TITLE = 'Meals Plus';

export const LUNCH_APPLICATION_WEBSITE_NAME = 'LunchApplication.com';



// WEBPACK FOOTER //
// ./src/common/Constants/website.js